<template>
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!-- 新增：标题输入框 -->
      <el-form-item label="标题：">
        <el-input v-model="curItem.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      
      <!-- 新增：介绍输入框 -->
      <el-form-item label="介绍：">
        <el-input 
          type="textarea" 
          v-model="curItem.description" 
          placeholder="请输入介绍"
          :rows="3"
        ></el-input>
      </el-form-item>

      <!-- 从导航组件迁移过来的图片上传部分 -->
      <el-form-item label="图片：">
        <draggable class="wrapper" v-model="curItem.data" :options="{ animation: 120, filter: '.drag__nomove' }" v-if="curItem.data && curItem.data.length">
          <div class="param-img-item" :key="index" v-for="(item, index) in curItem.data">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="$parent.onEditorDeleleData(index, selectedIndex)"></i>
            </div>
            
            <!-- 图标类型选择 -->
            <el-form-item label="图标类型：">
              <el-radio-group v-model="item.icon_type">
                <el-radio :label="10">图标</el-radio>
                <el-radio :label="20">图片</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 图片上传部分 -->
            <div v-if="Number(item.icon_type) === 20">
              <div class="icon">
                <img v-img-url="item.imgUrl" alt="" @click="$parent.onEditorSelectImage(item, 'imgUrl')">
              </div>
              <p class="tc gray9">建议尺寸100x100</p>
            </div>
            
            <!-- 图标设置部分 -->
            <div v-else>
              <div class="url-box">
                <span class="key-name">图标：</span>
                <selectIcon :icon_text.sync="item.icon"></selectIcon>
              </div>
              <div class="url-box">
                <span class="key-name">图标颜色：</span>
                <el-radio-group v-model="item.colorConf" style="line-height: 40px">
                  <el-radio :label="30">默认主题色</el-radio>
                  <el-radio :label="10">纯色</el-radio>
                  <el-radio :label="20">渐变色</el-radio>
                </el-radio-group>
              </div>
              <div class="url-box" v-if="Number(item.colorConf) === 20">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="item.color1"></el-color-picker>
                <el-color-picker v-model="item.color2"></el-color-picker>
                <el-color-picker v-model="item.color3"></el-color-picker>
              </div>
              <div class="url-box" v-if="Number(item.colorConf) === 10">
                <span class="key-name">请选择：</span>
                <el-color-picker v-model="item.solidColor"></el-color-picker>
              </div>
            </div>

            <!-- 文字内容 -->
            <div class="url-box">
              <span class="key-name">文字内容：</span>
              <el-input v-model="item.text"></el-input>
            </div>
            
            <!-- 文字颜色 -->
            <div class="url-box">
              <span class="key-name">文字颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="item.font_color"></el-color-picker>
                <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
                  重置
                </el-button>
              </div>
            </div>
            
            <!-- 链接设置 -->
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">链接名称：</span>
                <el-input :value="item.name+item.linkUrl"></el-input>
              </div>
              <div class="url-box ml10">
                <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
              </div>
            </div>
          </div>
        </draggable>
        
        <!-- 添加按钮 -->
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
      
      <SetLink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkSet">选择链接</SetLink>
    </el-form>
  </div>
</template>

<script>
import SetLink from '@/components/setlink/Setlink';
import draggable from "vuedraggable";
import selectIcon from "@/components/page/selectIcon";

export default {
  components: {
    SetLink,
    draggable,
    selectIcon,
  },
  data() {
    return {
      is_linkset: false,
      index: null,
    };
  },
props: {
    curItem: {
      type: Object,
      default: () => ({
        name: '',
        title: '',
        description: '',
        data: [],  // 确保data初始化为空数组
        style: {}
      })
    },
    selectedIndex: Number,
    opts: Object
  },
  methods: {
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },
    closeLinkSet(e) {
  if (e && this.curItem.data && this.curItem.data[this.index]) {
    this.$set(this.curItem.data[this.index], 'linkUrl', e.url);
    this.$set(this.curItem.data[this.index], 'name', '链接到' + ' ' + e.type + ' ' + e.name);
    if (e.appid) {
      this.$set(this.curItem.data[this.index], 'appid', e.appid);
    }
  }
  this.is_linkset = false;
},
  }
};
</script>

<style>
/* 添加必要的样式 */
.param-img-item {
  position: relative;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.delete-box {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.url-box {
  margin-bottom: 15px;
}

.key-name {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
}

.icon img {
  max-width: 100px;
  max-height: 100px;
  cursor: pointer;
}

.tc {
  text-align: center;
}

.gray9 {
  color: #999;
}

.d-s-c {
  display: flex;
  align-items: center;
}

.d-c-c {
  display: flex;
  justify-content: center;
}

.ml10 {
  margin-left: 10px;
}

.flex-1 {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/page/page/diy/params/Usea.vue